var render = function render(){var _vm=this,_c=_vm._self._c;return _c('draggable',{staticClass:"draggable-col-container",attrs:{"group":_vm.group,"sort":false,"list":_vm.list}},_vm._l((_vm.list),function(element){return _c('div',{key:`element-${element.id}`,staticClass:"border-bottom draggable-item"},[_c('div',{staticClass:"card-body p-3"},[_vm._v(_vm._s(element.data[_vm.itemName]))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }